import Vue from 'vue';
import Meta from 'vue-meta';
import VueRouter from 'vue-router';
import store from '@/store';
import routes from '@/router/routes';

Vue.use(Meta, {
  refreshOnceOnNavigation: true,
});
Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  const isAuthenticated = (store.state.user.token !== null);
  const requireAuth = (to.matched.some((route) => route.meta.requireAuth));
  const toAuthPages = (to.name === 'Login' || to.name === 'Register');

  if (requireAuth && !isAuthenticated) {
    next('/login');
  } else if (toAuthPages && isAuthenticated) {
    next('/dashboard');
  } else {
    next();
  }
});

export default router;
